__turbopack_context__.v({
  "container": "ButtonMenuMobile-module__B65-sG__container",
  "fadeInItems": "ButtonMenuMobile-module__B65-sG__fadeInItems",
  "spacing--lg": "ButtonMenuMobile-module__B65-sG__spacing--lg",
  "spacing--md": "ButtonMenuMobile-module__B65-sG__spacing--md",
  "spacing--sm": "ButtonMenuMobile-module__B65-sG__spacing--sm",
  "spacing--xl": "ButtonMenuMobile-module__B65-sG__spacing--xl",
  "spacing--xs": "ButtonMenuMobile-module__B65-sG__spacing--xs",
  "spacing--xxl": "ButtonMenuMobile-module__B65-sG__spacing--xxl",
  "spacing--xxs": "ButtonMenuMobile-module__B65-sG__spacing--xxs",
  "spacing--xxxl": "ButtonMenuMobile-module__B65-sG__spacing--xxxl",
  "spacing--xxxs": "ButtonMenuMobile-module__B65-sG__spacing--xxxs",
});
